import { observer } from 'mobx-react';
import { useState } from 'react';
import { MetadataArrowRightIcon, MetadataInfoIcon } from '../../assets/icons';
import { SectionWrapper, SectionHeader, SectionHeaderLeft, SectionHeaderRight, SectionIcon, SectionTitle, ArrowIcon, SectionContent, FileInfoRow, FileInfoLabel, FileInfoValueContainer, FileInfoValue, FileInfoSubtext } from './MetadataFileInfoSection.styles';

export const MetadataFileInfoSection = observer(({ file }) => {
    const [fileInfoOpen, setFileInfoOpen] = useState(false);

    const handleFileInfoToggle = () => setFileInfoOpen(!fileInfoOpen);

    const getFileTypeDisplay = (fileName, fileType) => {
        const extension = fileName?.split('.').pop()?.toLowerCase() || fileType?.toLowerCase();
        switch (extension) {
            case 'xls':
            case 'xlsx':
                return 'Microsoft Excel (.xlsx)';
            case 'pdf':
                return 'PDF Document (.pdf)';
            case 'doc':
            case 'docx':
                return 'Microsoft Word (.docx)';
            default:
                return `${extension?.toUpperCase()} File (.${extension})`;
        }
    };

    const formatFileSize = (sizeInBytes) => {
        if (!sizeInBytes) return 'Unknown size';
        
        const units = ['B', 'KB', 'MB', 'GB'];
        let size = sizeInBytes;
        let unitIndex = 0;
        
        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex++;
        }
        
        return `${Math.round(size * 10) / 10}${units[unitIndex]}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return null;
        
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    };

    const getUploadedBy = () => {
        return file?.uploadedByName || file?.uploadedBy || file?.createdBy?.name || file?.createdBy || 'Unknown';
    };

    const getModifiedBy = () => {
        return file?.lastModifiedByName || file?.modifiedBy || file?.updatedBy?.name || file?.updatedBy || getUploadedBy();
    };

    return (
        <SectionWrapper>
            <SectionHeader isOpen={fileInfoOpen} onClick={handleFileInfoToggle}>
                <SectionHeaderLeft>
                    <SectionIcon><MetadataInfoIcon /></SectionIcon>
                    <SectionTitle>File info</SectionTitle>
                </SectionHeaderLeft>
                <SectionHeaderRight>
                    <ArrowIcon isOpen={fileInfoOpen}><MetadataArrowRightIcon /></ArrowIcon>
                </SectionHeaderRight>
            </SectionHeader>
            {fileInfoOpen && (
                <SectionContent>
                    <FileInfoRow>
                        <FileInfoLabel>File type</FileInfoLabel>
                        <FileInfoValueContainer>
                            <FileInfoValue>{getFileTypeDisplay(file?.originalName, file?.type)}</FileInfoValue>
                            <FileInfoSubtext>{formatFileSize(file?.size)}</FileInfoSubtext>
                        </FileInfoValueContainer>
                    </FileInfoRow>
                    <FileInfoRow>
                        <FileInfoLabel>Uploaded</FileInfoLabel>
                        <FileInfoValueContainer>
                            <FileInfoValue>{formatDate(file?.createdAt) || 'Unknown date'}</FileInfoValue>
                            <FileInfoSubtext>by {getUploadedBy()}</FileInfoSubtext>
                        </FileInfoValueContainer>
                    </FileInfoRow>
                    <FileInfoRow>
                        <FileInfoLabel>Last modified</FileInfoLabel>
                        <FileInfoValueContainer>
                            <FileInfoValue>{formatDate(file?.updatedAt) || formatDate(file?.createdAt) || 'Unknown date'}</FileInfoValue>
                            <FileInfoSubtext>by {getModifiedBy()}</FileInfoSubtext>
                        </FileInfoValueContainer>
                    </FileInfoRow>
                </SectionContent>
            )}
        </SectionWrapper>
    );
}); 